import { render, staticRenderFns } from "./city-owner.vue?vue&type=template&id=e85e5422"
import script from "./city-owner.vue?vue&type=script&lang=js"
export * from "./city-owner.vue?vue&type=script&lang=js"
import style0 from "./city-owner.vue?vue&type=style&index=0&id=e85e5422&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports